import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';

import VereadorBlockData from './Data';
import VereadorBlockView from './View';

const VereadorBlockEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  return (
    <>
      <VereadorBlockView {...props} isEditMode />
      <SidebarPortal selected={selected}>
        <VereadorBlockData
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(VereadorBlockEdit);
